<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Cieyup/images/9780312329730.jpg?1726444398007" alt="This image is the cover for the book Wedding Belles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wedding Belles
      </h1>
      <p class="bookDescription body article font2">
        <p>The <i>New York Times</i> bestselling author of <i>The Red Hat Club</i> fearlessly takes on mothers and daughters, wedding madness, and midlife passion in this frank, funny, and fabulous new novel.<br/><br/>Georgia, Linda, Diane, Teeny, and Pru have been best friends since high school, and never have they needed one another more. Georgia's precious twenty-eight-year-old daughter, Callie, has gone and gotten engaged. Usually this would be cause for celebration. After all, this is the South, where dreams of white dresses and wedding bells are as important as finding the perfect hat. But Callie's intended groom just happens to be a man <i>they</i> went to high school and college with: Wild Man Wade! These women know more about the groom than the bride does. His drunken shenanigans. His wild oats. And <i>all</i> of his conquests as well as his mistakes. They can imagine him in the most inappropriate of circumstances, but not as a son-in-law! <br/><br/>With absolutely hilarious Southern observances and dead-on wit about mothers, daughters, marriage, and families, <i>Wedding Belles</i> will have you laughing and crying whether you live above or below the Mason-Dixon line.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Haywood Smith
      </h2>
      
      <p class="authorDescription body article"><P>Haywood Smith is the <I>New York Times</I> and <I>USA Today</I> bestselling author of <I>The Red Hat Club</I> and <I>The Red Hat Club Rides Again.</I> She lives in Buford, Georgia.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin's Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e1d978e6